
    <div>

        <div class="busy-overlay-parent d-flex flex-row pb-2" [ngClass]="isLoading||isSaving||!logService.isReady()?'disabled':''">
            <div *ngIf="isLoading||isSaving||!logService.isReady()" class="font-italic busy-overlay">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading comments...
            </div>
            <div class="d-flex flex-column flex-fill">
                <textarea class="flex-fill" placeholder="Enter comments here" [formControl]="comments">
                </textarea>
                <div *ngIf="validationFailed && comments.invalid" class="text-white bg-warning text-nowrap font-smaller">
                Comments cannot be empty
                </div>
            </div>
            <div class="d-flex flex-row">
                <button class="btn btn-secondary text-center ml-2" (click)="onCommentBtnClick()" [disabled]="isLoading||isSaving">
                    Log<br/>Comment
                </button>
            </div>
        </div>
        
        <div>
            <div *fesListView="let logRows of logRows$ | async">
            <table class="comment-table table table-striped table-bordered table-sm mb-1">
                <thead>
                <tr>
                    <th fesSortField="timestamp" class="text-center">Comments</th>
                    <th class="font-smaller" style="width:4em;">Assist</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="!isLoading&&logRows.length==0">
                    <td colspan=2 class="text-muted italic">No entries found</td>
                </tr> 
                <tr *ngFor="let logRow of logRows" [class]="logRow.rowClass">
                    <ng-container *ngIf="!logRow.archived; else elseBlock">
                        <td>
                            <div class="comment-date">{{logRow.timestamp|date:'yyyy-MM-dd HH:mm:ss'}}</div>
                            <div class="delete-log">
                                <i role="button" (click)="archive(logRow.pointTestLogDoc,true)">[delete]</i>
                            </div>
                            <div>{{logRow.text}}</div>
                        </td>
                        <td class="text-center align-middle"><a href="javascript:false;" 
                            (click)="assistanceDetail(assistanceModalTemplate,logRow.pointTestLogDoc.assistanceId)">view</a></td>
                    </ng-container>
                    <ng-template #elseBlock>
                        <td *ngIf="showDeleted" class="deleted-row">
                            <div class="deleted-text">{{logRow.text}}</div>
                            <div class="restore-log">
                                <i role="button" (click)="archive(logRow.pointTestLogDoc,false)">[restore]</i>
                            </div>
                        </td>
                        <td class="deleted-row" *ngIf="showDeleted"></td>
                    </ng-template>
                </tr>
                </tbody>
            </table>
            <div class="d-flex flex-row justify-content-between">
                <div class="w-100 pr-1">
                    <input *ngIf="logRows.length > 0" type="text" fesFilterField="text" class="w-100 ml-1" placeholder="Filter comments...">
                </div>
                <div *ngIf="someCommentsDeleted" class="pl-2 text-right text-nowrap">
                    <input id="show-deleted" type="checkbox" name="Show Deleted Comments" (change)="showDeletedChecked($any($event.target).checked)" [checked]="showDeleted">
                    <label for="show-deleted" class="small">Show Deleted</label>
                </div>
            </div>
        </div>
        </div>
    
        <ng-template #assistanceModalTemplate>
            <div class="modal-header">
                <div class="modal-title">Assistance</div>
                <button type="button" class="close pull-right" aria-label="Close" (click)="assistanceModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body"><app-assistance-view [assistanceId]="'TODO'"></app-assistance-view></div>
            <div class="modal-footer"><button (click)="assistanceModal.hide()">Close</button></div>
        </ng-template>
    </div>
    